<nz-card class="flow-card" nzTitle="Dish Gift Card Lookup">
  <p class="flow-card__subtitle">Confirm gift card eligibility before moving the sale forward.</p>

  <form nz-form [formGroup]="preQualForm" [nzLayout]="'vertical'" nzNoColon class="flow-form">
    <nz-form-item class="flow-form__item">
      <nz-form-control>
        <label nz-checkbox formControlName="hasPreQualCode">
          Use gift card code?
        </label>
      </nz-form-control>
    </nz-form-item>

    <ng-container *ngIf="!preQualForm.get('hasPreQualCode')?.value">
      <nz-card nzType="inner" class="flow-card__inner">
        <h3>No code? No problem.</h3>
        <p>Continue to the next step or switch on gift card lookup to surface prefilled customer details.</p>
      </nz-card>
    </ng-container>

    <ng-container *ngIf="preQualForm.get('hasPreQualCode')?.value">
      <nz-form-item class="flow-form__item">
        <nz-form-label [nzRequired]="true" nzFor="preQualCode">Gift Card Number</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            id="preQualCode"
            type="text"
            inputmode="numeric"
            maxlength="12"
            minlength="9"
            formControlName="preQualCode"
            placeholder="Enter gift card number"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="flow-form__item">
        <nz-form-label [nzRequired]="true" nzFor="ssn">Last 4 of SSN</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            id="ssn"
            type="password"
            inputmode="numeric"
            maxlength="4"
            minlength="4"
            formControlName="ssn"
            placeholder="Last four digits"
          />
        </nz-form-control>
      </nz-form-item>

      <div class="flow-actions" *ngIf="!customerType">
        <button
          nz-button
          nzType="primary"
          nzBlock
          [disabled]="!preQualForm.valid"
          (click)="doPreQual()"
          [nzLoading]="verifyGCSpinner"
        >
          Verify Gift Card Code
        </button>
      </div>

      <div class="status-stack" *ngIf="customerType || preQualType || failedPQ">
        <nz-alert *ngIf="customerType" nzType="success" [nzMessage]="customerType" nzShowIcon></nz-alert>
        <nz-alert *ngIf="preQualType" nzType="info" [nzMessage]="'Gift card reward: ' + preQualType" nzShowIcon></nz-alert>
        <nz-alert *ngIf="failedPQ" nzType="error" [nzMessage]="failedPQ" nzShowIcon></nz-alert>
      </div>
    </ng-container>

    <div class="flow-actions flow-actions--trailing">
      <button
        nz-button
        nzType="primary"
        nzBlock
        [disabled]="preQualForm.get('hasPreQualCode')?.value && !customerType"
        (click)="nextStep()"
        [nzLoading]="nextLoading"
      >
        Next Step
      </button>
    </div>
  </form>
</nz-card>
